"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createUniqueElementIds = require("../../utils/createUniqueElementIds/createUniqueElementIds");

var _DescriptionMessages = _interopRequireDefault(require("../FormControlFragments/DescriptionMessages"));

var _InputLabel = _interopRequireDefault(require("../FormControlFragments/InputLabel"));

var _excluded = ["ariaLabelledBy", "autoCapitalize", "autoComplete", "autoCorrect", "classes", "dataTestId", "description", "descriptionId", "errorMessages", "formControlId", "handleOnBlurValidation", "handleOnChange", "handleOnKeyPress", "initialValue", "inputId", "isDescriptionHtml", "isDisabled", "isOptional", "isRequired", "isValid", "label", "labelId", "maxLength", "minLength", "name", "placeholder", "size", "spellcheck"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Textarea = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaLabelledBy = _ref.ariaLabelledBy,
      autoCapitalize = _ref.autoCapitalize,
      autoComplete = _ref.autoComplete,
      autoCorrect = _ref.autoCorrect,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      errorMessages = _ref.errorMessages,
      formControlId = _ref.formControlId,
      handleOnBlurValidation = _ref.handleOnBlurValidation,
      handleOnChange = _ref.handleOnChange,
      handleOnKeyPress = _ref.handleOnKeyPress,
      initialValue = _ref.initialValue,
      inputId = _ref.inputId,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isOptional = _ref.isOptional,
      isRequired = _ref.isRequired,
      isValid = _ref.isValid,
      label = _ref.label,
      labelId = _ref.labelId,
      maxLength = _ref.maxLength,
      minLength = _ref.minLength,
      name = _ref.name,
      placeholder = _ref.placeholder,
      size = _ref.size,
      spellcheck = _ref.spellcheck,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('label')),
      _useState4 = _slicedToArray(_useState3, 1),
      labelUniqueId = _useState4[0];

  var _useState5 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('textarea')),
      _useState6 = _slicedToArray(_useState5, 1),
      inputUniqueId = _useState6[0];

  var _useState7 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('description')),
      _useState8 = _slicedToArray(_useState7, 1),
      descriptionUniqueId = _useState8[0];

  var handleSetValue = function handleSetValue(event) {
    return setValue(event.target.value);
  };

  var textAreaWrapperStyles = (0, _classnames.default)('form-control__textarea-wrapper', {
    'form-control__textarea-wrapper--small': size === 'small'
  });
  var formControlStyles = (0, _classnames.default)('form-control__container', {
    'form-control__container--error': !isValid,
    'form-control__container--disabled': isDisabled
  }, classes);

  var textareaElement = /*#__PURE__*/_react.default.createElement("textarea", _extends({
    id: inputId || inputUniqueId,
    name: name,
    value: value,
    onBlur: function onBlur() {
      if (handleOnBlurValidation) {
        handleOnBlurValidation(value);
      }
    },
    onChange: function onChange(event) {
      handleSetValue(event);

      if (handleOnChange) {
        handleOnChange(event);
      }
    },
    onKeyPress: handleOnKeyPress,
    autoComplete: autoComplete,
    autoCorrect: autoCorrect,
    autoCapitalize: autoCapitalize,
    required: isRequired || null,
    disabled: isDisabled || null,
    "aria-disabled": isDisabled || null,
    "aria-required": isRequired || null,
    "aria-invalid": !isValid || null,
    "aria-labelledby": ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(labelId || labelUniqueId) : null,
    "aria-describedby": (description || errorMessages && !isValid) && (descriptionId || descriptionUniqueId) || null,
    placeholder: placeholder,
    minLength: minLength,
    maxLength: maxLength,
    className: "form-control__textarea",
    ref: ref,
    spellCheck: spellcheck,
    "data-testid": dataTestId
  }, additionalProps));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: formControlStyles,
    id: formControlId
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    inputId: inputId,
    inputUniqueId: inputUniqueId,
    isDisabled: isDisabled,
    isOptional: isOptional,
    isValid: isValid,
    label: label,
    labelId: labelId,
    labelUniqueId: labelUniqueId
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: textAreaWrapperStyles
  }, textareaElement), (description || errorMessages.length > 0 && !isValid) && /*#__PURE__*/_react.default.createElement(_DescriptionMessages.default, {
    description: description,
    descriptionId: descriptionId,
    descriptionUniqueId: descriptionUniqueId,
    errorMessages: errorMessages,
    isDescriptionHtml: isDescriptionHtml,
    isDisabled: isDisabled,
    isValid: isValid
  }));
}); // needed for prop type checking refs in server side rendered apps

var Element = typeof Element === 'undefined' ? function () {} : Element; // eslint-disable-line

Textarea.displayName = 'Textarea';
Textarea.propTypes = {
  /**
   Optional. Adds `aria-labelledby` attribute to associate the input with a page level error message.
   */
  ariaLabelledBy: _propTypes.default.string,

  /**
   Optional. Controls how the entered text is automatically capitalized via virtual keyboards and voice input.
   */
  autoCapitalize: _propTypes.default.oneOf(['none', 'sentences', 'words', 'characters']),

  /**
   Optional. Allows the user agent to provide assistance in filling out form field values by hinting or suggesting values to the user. Also helps the browser know what type of info to expect.
   */
  autoComplete: _propTypes.default.oneOf(['off', 'on']),

  /**
   Optional. A Safari extension that indicates whether or not to activate automatic correction while the user is editing the field.
   */
  autoCorrect: _propTypes.default.oneOf(['on', 'off']),

  /**
   Optional. String to add custom class(es) to the component.
   */
  classes: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Custom description that appears below the checkbox. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. A unique identifier passed to the description's `id` attribute. Defaults to `null`.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. Array of error message strings displayed when `isValid` is `false`.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. A unique identifier passed to the component wrapper's `id` attribute. Defaults to `null`.
   */
  formControlId: _propTypes.default.string,

  /**
   Optional. A function passed in to validate the textarea value on blur. The value for the textarea must be passed in (`(v) => formatCallback(v)`) and will update when the textarea is blurred.
   */
  handleOnBlurValidation: _propTypes.default.func,

  /**
   Optional. The function passed to the input's `onChange` method.
   */
  handleOnChange: _propTypes.default.func,

  /**
   Optional. The function passed to the input's `onKeyPress` method.
   */
  handleOnKeyPress: _propTypes.default.func,

  /**
   Optional. Initial value of the textarea. Defaults to `''`.
   */
  initialValue: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the input's `id` attribute. Defaults to `null`.
   */
  inputId: _propTypes.default.string,

  /**
   Optional. Used to pass HTML to the `description` prop. Defaults to `false`.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
   Optional. Passes the `disabled` prop to the checkbox input. Defaults to `false`.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Should not be used if `isRequired` is used. Adds "Optional" text to the right of the legend. Defaults to `false`.
   */
  isOptional: _propTypes.default.bool,

  /**
   Optional. Adds the `required` attribute to the input. Defaults `false`.
   */
  isRequired: _propTypes.default.bool,

  /**
   Optional. Sets the error state for the component and it's checkboxes when set to `false`. Defaults to `true`.
   */
  isValid: _propTypes.default.bool,

  /**
   Required. The label that appears above the textarea input.
   */
  label: _propTypes.default.string.isRequired,

  /**
   Optional. A unique identifier passed to the input label's `id` attribute. Defaults to `null`.
   */
  labelId: _propTypes.default.string,

  /**
   Optional. Sets the maxLength attribute for the textarea.
   */
  maxLength: _propTypes.default.number,

  /**
   Optional. Sets the minLength attribute for the textarea.
   */
  minLength: _propTypes.default.number,

  /**
   Optional. The name attribute for the input, which gets associated to the value. Defaults to `null`.
   */
  name: _propTypes.default.string,

  /**
   Optional. Custom placeholder for textarea.
   */
  placeholder: _propTypes.default.string,

  /**
    Optional. Controls the size of the box and label. Defaults to 'large'.
    */
  size: _propTypes.default.oneOf(['large', 'small']),

  /**
   Optional. Specifies whether the textarea is subject to spell checking by the underlying browser/OS.
   */
  spellcheck: _propTypes.default.oneOf(['true', 'false'])
};
Textarea.defaultProps = {
  ariaLabelledBy: null,
  autoCapitalize: null,
  autoComplete: null,
  autoCorrect: 'off',
  classes: '',
  dataTestId: null,
  description: '',
  descriptionId: '',
  errorMessages: [],
  formControlId: null,
  handleOnBlurValidation: function handleOnBlurValidation() {},
  handleOnChange: null,
  handleOnKeyPress: function handleOnKeyPress() {},
  initialValue: '',
  inputId: '',
  isDescriptionHtml: false,
  isDisabled: false,
  isOptional: false,
  isRequired: false,
  isValid: true,
  labelId: '',
  maxLength: null,
  minLength: null,
  name: null,
  placeholder: null,
  size: 'large',
  spellcheck: 'true'
};
var _default = Textarea;
exports.default = _default;